import styled from 'styled-components';
import { DownOutlined } from '@ant-design/icons';
import { ICustomSelectProps } from 'store/ducks/Global/types';

export const SelectWrapper = styled('div')<ICustomSelectProps>`
  padding: unset !important;

  .ant-select-clear {
    font-size: 18px !important;
    width: 20px !important;
    height: 20px !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    max-width: ${(props) =>
      props.size === 'lg' ? '160px' : props.size === 'md' ? '140px' : '120px'};
    min-width: ${(props) =>
      props.size === 'lg' ? '160px' : props.size === 'md' ? '140px' : '120px'};
  }

  .ant-select-selection-placeholder {
    padding-left: 8px !important;
    color: #999999 !important;
  }

  .ant-select-selection-item {
    padding-left: 8px !important;
    color: #000000 !important;
  }
`;

export const FiltersWrapper = styled('div')`
  .ant-select-clear {
    font-size: 18px !important;
    width: 20px !important;
    height: 20px !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    width: 160px !important;
    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;
  }

  .ant-select-arrow {
    right: 8px !important;
    left: auto !important;
  }

  .ant-select-selection-placeholder {
    text-align: initial;
    color: #5d5a5a;
  }

  .ant-select-selection-item {
    padding-left: 8px !important;
    color: #000000 !important;
  }
`;

export const StyledDownOutlined = styled(DownOutlined)`
  margin-left: 0px;
  margin-right: 0px;
`;

export const GlobalDropdownStyles = `
  .ant-select-dropdown {
    width: 800px !important;
    min-width: 800px !important;
    max-width: 800px !important;
  }
  
  .ant-select-item {
    font-size: 18px !important;
    padding: 15px 20px !important;
    min-height: 50px !important;
  }
  
  .ant-select-item-option-content {
    font-size: 18px !important;
  }
`;
